import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const ServiceMenuStyles = styled.div`
  .headerCard {
    margin-bottom: ${({ theme }) => theme.spacing[16]};
  }

  .cardHeaderRow {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .addServiceBtn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .searchBar {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[12]};
    width: 100%;

    /* On mobile the 280px search + dropdown + export overflow the row and crush
       the search input to nothing; let the search take the full first line and
       wrap the type filter + export button below it. */
    ${media.maxTablet`
      flex-wrap: wrap;

      .searchContainer {
        width: 100%;
      }
    `}
  }

  .tableCard {
    overflow: hidden;
  }

  .searchContainer {
    width: 280px;
    height: 42px;
    border-radius: ${({ theme }) => theme.radius[12]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    overflow: hidden;
    color: ${({ theme }) => theme.colors.semantic.icon.weak};
    transition: border-color 0.2s ease, color 0.2s ease;

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.semantic.text.strong};
      color: ${({ theme }) => theme.colors.semantic.icon.strong};
    }

    .searchInput {
      border: none;
      border-radius: 0;
    }
  }

  .typeDropdown {
    position: relative;
    flex-shrink: 0;
  }

  .typeDropdownBtn {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[8]};
    padding: 10px ${({ theme }) => theme.spacing[16]};
    border-radius: ${({ theme }) => theme.radius[12]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    cursor: pointer;
    white-space: nowrap;
    outline: none;
    transition: all 0.2s ease;

    &:hover,
    &.open {
      border-color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .chevron {
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 5px solid ${({ theme }) => theme.colors.semantic.text.weak};
      transition: transform 0.2s ease;
    }

    &.open .chevron {
      transform: rotate(180deg);
    }
  }

  .typeDropdownMenu {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    min-width: 180px;
    /* The button sits on the left on mobile, so open the menu leftward-aligned
       (right:0 would push it off the left edge of the card). */
    ${media.maxTablet`
      right: auto;
      left: 0;
    `}
    border-radius: ${({ theme }) => theme.radius[12]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    z-index: 10;
    padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]};
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .typeDropdownItem {
    padding: 6px ${({ theme }) => theme.spacing[16]};
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    cursor: pointer;
    border-radius: 999px;
    border: 1.5px solid transparent;
    transition: all 0.15s ease;

    &:hover {
      background: ${({ theme }) => theme.colors.accent[50]};
    }

    &.selected {
      background: ${({ theme }) => theme.colors.semantic.container.white};
      border-color: ${({ theme }) => theme.colors.semantic.text.strong};
      font-weight: 600;
    }
  }

  /* Visually matches the .btn .btn-sm pill on the Analytics dashboard
     (modules/.../analytics/DashboardFilters/dashboardFilters.styles.js).
     margin-left: auto pushes it to the far right of the search row. */
  .exportMenuBtn {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: inherit;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.1px;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    background: #fff;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    transition: background 0.12s, color 0.12s, border-color 0.12s;
    white-space: nowrap;

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.accent[50]};
      color: ${({ theme }) => theme.colors.accent[500]};
      border-color: ${({ theme }) => theme.colors.accent[500]};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
